<script setup>
import dayjs from 'dayjs';
import { ref, onMounted } from 'vue';
let showingNavigationDropdown = ref(false);
const navItems = [
   
];

const props = defineProps({
    user: {
        type: Object,
        default: () => ({ full_name: 'User Name' }),
    },
    company: {
        type: Object,
        default: () => ({ short_name: 'Company Name' }),
    },
    logout: {
        type: Function,
        default: () => {
            console.log('Logout function not provided');
        },
    },
    
});

const env = ref("")
const domain = ref("")

async function loadCredentials() {
    env.value = await OfficeRuntime.storage.getItem("environment");
    domain.value = 'https://' + env.value + '.todmarkets.com.au'
}

onMounted(async () => {
    await loadCredentials();
});
</script>
<template>
    <div class="min-h-screen bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300">
        <nav class="bg-white dark:bg-gray-800 border-b border-gray-100 dark:border-gray-700">
            <!-- Primary Navigation Menu -->
            <div class=" mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between h-16">
                    <div class="flex">
                        <!-- Logo -->
                        <div class="shrink-0 flex items-center">
                            <img src="/assets/icon-64.png"
                                class="block h-9 w-auto fill-current text-gray-800 dark:text-gray-200" />
                        </div>
                    </div>
                    <!-- Hamburger -->
                    <div class="-mr-2 flex items-center">
                        <button @click="showingNavigationDropdown = !showingNavigationDropdown"
                            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-900 focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-900 focus:text-gray-500 dark:focus:text-gray-400 transition duration-150 ease-in-out">
                            <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path :class="{
                                    hidden: showingNavigationDropdown,
                                    'inline-flex': !showingNavigationDropdown,
                                }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16" />
                                <path :class="{
                                    hidden: !showingNavigationDropdown,
                                    'inline-flex': showingNavigationDropdown,
                                }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <!-- Responsive Navigation Menu -->
            <div :class="{ block: showingNavigationDropdown, hidden: !showingNavigationDropdown }"
                class="absolute z-50 bg-gray-900 w-full">
                <div>
                    <a v-for="item in navItems">
                        {{ item.label }}
                    </a>
                </div>

                <!-- Responsive Settings Options -->
                <div class="pt-4 pb-1 border-t border-b border-gray-200 dark:border-gray-600">
                    <div class="px-4">
                        <div
                            class="font-medium text-base text-gray-800 dark:text-gray-200 border-b border-gray-500 pb-2">
                            {{ props.user?.full_name ?? 'user name' }}
                            <br>{{ props.company?.name ?? 'company name' }}
                            <br> {{ env }}
                        </div>
                    </div>

                    <div class="mt-3 space-y-1">
                        <a class="block w-full pl-3 pr-4 py-2 border-l-4 border-transparent text-left text-base font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-800 dark:focus:text-gray-200 focus:bg-gray-50 dark:focus:bg-gray-700 focus:border-gray-300 dark:focus:border-gray-600 transition duration-150 ease-in-out"
                            :href="domain+'/market'" target="_blank">
                            Market View </a>
                        <a class="block w-full pl-3 pr-4 py-2 border-l-4 border-transparent text-left text-base font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-800 dark:focus:text-gray-200 focus:bg-gray-50 dark:focus:bg-gray-700 focus:border-gray-300 dark:focus:border-gray-600 transition duration-150 ease-in-out"
                            :href="domain+'/activity-feed'" target="_blank">
                            Activity Feed </a>
                        <a class="block w-full pl-3 pr-4 py-2 border-l-4 border-transparent text-left text-base font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-800 dark:focus:text-gray-200 focus:bg-gray-50 dark:focus:bg-gray-700 focus:border-gray-300 dark:focus:border-gray-600 transition duration-150 ease-in-out"
                            :href="domain+'/orders'" target="_blank">
                            Orders </a>
                        <a class="block w-full pl-3 pr-4 py-2 border-l-4 border-transparent text-left text-base font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-800 dark:focus:text-gray-200 focus:bg-gray-50 dark:focus:bg-gray-700 focus:border-gray-300 dark:focus:border-gray-600 transition duration-150 ease-in-out"
                            href="https://todmarkets.atlassian.net/wiki/spaces/TML/overview?homepageId=55541997"
                            target="_blank">
                            Documentation </a>
                        <a class="block w-full pl-3 pr-4 py-2 border-l-4 border-transparent text-left text-base font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-800 dark:focus:text-gray-200 focus:bg-gray-50 dark:focus:bg-gray-700 focus:border-gray-300 dark:focus:border-gray-600 transition duration-150 ease-in-out"
                            href="https://todmarkets.atlassian.net/servicedesk/customer/portal/1" target="_blank">
                            Feedback & Support </a>
                        <button
                            class="block w-full pl-3 pr-4 py-2 border-l-4 border-transparent text-left text-base font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-800 dark:focus:text-gray-200 focus:bg-gray-50 dark:focus:bg-gray-700 focus:border-gray-300 dark:focus:border-gray-600 transition duration-150 ease-in-out"
                            @click="props.logout()">
                            Log Out
                        </button>
                    </div>
                </div>
            </div>
        </nav>
        <main class="h-full ">
            <slot />
        </main>
        <footer>
            <div class="max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
                <slot name="footer" />

            </div>
            <!-- copywrite TOD Markets current year -->
            <div class="max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
                <p class="text-center text-gray-500 text-xs">
                    For broker or technical support call +61 7 2112 3055
                </p>
                <p class="text-center text-gray-500 text-xs mt-2">
                    TOD Markets Pty Ltd ABN 32675980604, AFSL:548573 CAR:001311315 (Trading as TOD Markets)
                </p>
                <p class="text-center text-gray-500 text-xs">
                    &copy; {{ dayjs().format('YYYY') }} TOD Markets. All rights reserved.
                </p>
            </div>
        </footer>
    </div>
</template>